import ArrowIcon from "./arrow-icon"
import LineIcon from "./line-icon"
import CircleIcon from "./circle-icon"
import ChevronIcon from "./chevron-icon"
import CloseIcon from "./close-icon"
import ExclamationIcon from "./exclamation-icon.js"
import SearchIcon from "./search-icon"
import TrashIcon from "./trash-icon"
import FilterIcon from "./filter-icon"
import ExternalLinkIcon from "./external-link-icon"
import InformationIcon from "./information-icon"
import HamburgerIcon from "./hamburger"

import CampaignIcon from "./campaign-icon"
import InstrumentIcon from "./instrument-icon"
import PlatformIcon from "./platform-icon"
import CaseiLogoIcon from "./casei-logo-icon"

import DiscoveryIcon from "./about/discovery-icon"
import AccountingIcon from "./about/accounting-icon"
import MetadataIcon from "./about/metadata-icon"

export {
  ArrowIcon,
  LineIcon,
  CircleIcon,
  ChevronIcon,
  CloseIcon,
  ExclamationIcon,
  SearchIcon,
  TrashIcon,
  FilterIcon,
  ExternalLinkIcon,
  InformationIcon,
  HamburgerIcon,
}

export { CampaignIcon, InstrumentIcon, PlatformIcon, CaseiLogoIcon }

export { DiscoveryIcon, AccountingIcon, MetadataIcon }

export { AtmosphericComposition as AtmosphericCompositionIcon } from "./atmospheric-composition"
export { AtmosphericDynamics as AtmosphericDynamicsIcon } from "./atmospheric-dynamics"
export { CarbonCycleEcosystems as CarbonCycleEcosystemsIcon } from "./carbon-cycle_ecosystems"
export { ClimateVariabilityChange as ClimateVariabilityChangeIcon } from "./climate-variability_change"
export { EarthSurfaceInterior as EarthSurfaceInteriorIcon } from "./earth-surface_interior"
export { GlobalWaterEnergyCycle as GlobalWaterEnergyCycleIcon } from "./global-water_energy-cycle"
export { Weather as WeatherIcon } from "./weather"

export { AirborneRemoteSensors } from "./airborne-remote-sensors"
